import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <div className="copyright">
        <p>Made with <span className="heart" /> Brain Dynamics</p>
      </div>
    </div>
  );
};

export default Footer;
